import { MissingPasswordAction } from "./missing-password.action";

export const MISSING_PASSWORD_MESSAGE_CONTEXT = {
	setMissingPassword: MissingPasswordAction.set.type,
};

export const MISSING_PASSWORD_MESSAGE_CODES = {
	setMissingPassword: {
		success: "M_CHANGE_PASSWORD_SUCCESS",
		error: "E_SET_PASSWORD",
		tokenNotFound: "E_SET_PASSWORD_TOKENNOTFOUND",
		tokenInvalidValue: "E_VALIDATION_INVALIDVALUE",
	},
};

export const SKIP_MISSING_PASSWORD_KEY = "skipMissingPasswordShown";
export const CACHE_STORE_MISSING_PASSWORD = "ngx.common.missing-password";
